define(function (require) {
	const tpl = require('./templates/t_itv_dropdown_field.hbs');
	const baseElement = require('./v_itv_base_element');
	const detailUtils = require('civicsUtils/detail_utilities');
	const general_utilities = require('civicsUtils/general_utilities');
	require('civicsUtils/civicsDroppy');

	return baseElement.extend({
		optionFetchPromise:null,
		dropdownOptions:[],
		template:tpl,
		childInitialize:function(options){
			if(this.config.dropdowns == null){
				this.config.dropdowns = [];
			}
			//code definitions need to be sent to the server as an object with the value on the code attribute.
			//So we detect that here
			var bind = this.model.get('bind');
			if (bind && bind.toLowerCase().indexOf('.code') >= 0) {
				this.isCodeDef = true;
				if (this.model.get('value') instanceof Backbone.Collection && this.model.get('value.code')) {
					//pull the value out of the child object.
					this.model.set('value', this.model.get('value.code'), {silent:true});
				}
			} else {
				this.isCodeDef = false;
			}
			this.origValue = this.model.get('value');
			this.getOptions();
		},
		getOptions:function(){
			this.optionFetchPromise = $.Deferred();
			this.optionsLoadedFromCache = false;
			var moniker = this.model.get('moniker') ? this.model.get('moniker') : this.model.get('id');
			this.displayValue = this.model.get('value');
			if(this.model.get('valueSelections')){
				this.processValueSelectionOptions(moniker);
			} else {
				this.fetchOptions(moniker);
			}
		},
		fetchOptions:function(moniker){
			//loadOptions fetches the options and stores them on the detail page.
			var loadOptionsPromise = detailUtils.loadOptions(this.config.detailPageId, moniker , this.config.gridMoniker, !this.isCodeDef);
			$.when(loadOptionsPromise).done((retObj)=> {

				//retrieve the stored options and store for use in HBS
				var options = detailUtils.getOptions(this.config.detailPageId, moniker, this.config.gridMoniker, this.model.get('value'));
				this.dropdownOptions = options;
				$.each(options, (index, el) => {
					if (el.selected === true) {
						this.displayValue = el.description;
					}
				});
				this.optionsLoadedFromCache = retObj.loadedFromCache;
				this.optionFetchPromise.resolve();
			});
		},
		processValueSelectionOptions:function(moniker){
			let valueSelections = this.cleanupValueSelections(this.model.get('valueSelections'));
			
			//store the value selections for use later in the detail page.
			detailUtils.storeOptions(this.config.detailPageId, moniker , this.config.gridMoniker, valueSelections);
			//save the options for use in HBS. The store options function (above) converts valueSelections into options.
			var options = detailUtils.getOptions(this.config.detailPageId, moniker, this.config.gridMoniker, this.model.get('value'));
			$.each(options, (index, el) => {
					if (el.selected === true) {
						this.displayValue = el.description;
					}
				});
			this.dropdownOptions = options;
			this.optionsLoadedFromCache = true;
			this.optionFetchPromise.resolve();
		},
		cleanupValueSelections:function(valueSelections){
			if(valueSelections instanceof Backbone.Collection){
				valueSelections = valueSelections.toJSON();
			}
			//remove empty options
			valueSelections = valueSelections.filter((el)=> el.value!='' && el.description!='');

			//make sure we have a code attribute on each option.
			valueSelections.forEach((el)=>{ 
				if(el.code == null || el.code.trim() == "") {
					el.code = el.value;
				}
			});
			return valueSelections
		},
		alreadyRendered: false,
		onRender: function () {
			if(this.optionFetchPromise.state() != 'resolved') {
				$.when(this.optionFetchPromise).done(()=>{
					this.render();
				});
			}
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

			if(this.optionsLoadedFromCache || this.alreadyRendered) {
				this.triggerMethod('init:filtercodes');
			}

			this.alreadyRendered = true;
			baseElement.prototype.displayErrors.apply(this);
		},
		getValue: function () {
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			return general_utilities.civicsDropdownValue(this.$el.find('input'));
		},
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var self = this;
			var ret = {
				classes:'dropdown-container' + 
					(self.model.get('isVisible') === false ? ' hidden':'') +
					(self.model.get('fullWidthField') === true ? ' full-width' : ''),
				customAttr:function(){
					var ret = self.model.get('customAttr');
					ret += 'specialType="modalDdl" ';
					return ret;
				},
				options: self.dropdownOptions,
				value: this.model.get('value'),
				displayValue: this.displayValue
			};

			ret = $.extend({}, baseTH, ret);
			return ret;
		}

	});
});
